import { z } from 'zod';

const dictionaryItemDtoSchema = z.tuple([z.string(), z.string()]);

export const UiDictionariesDtoSchema = z.record(z.string(), z.array(dictionaryItemDtoSchema));

export type UiDictionariesDto = z.infer<typeof UiDictionariesDtoSchema>;
